import { AbsoluteContainer, AppLabel, AppSpan, AppText, CustomContainer, Divider, FlexRow, GridContainer, Icon } from "src/style"
import { AiFillCheckCircle } from "react-icons/ai"
import Passport from 'src/assets/img/passport.svg'
import UtilityBill from 'src/assets/img/utility-bill.svg'
import Signature from 'src/assets/img/signature.svg'
import IdCard from 'src/assets/img/id-card.svg'


export const CustomerData: React.FC<any> = ({data}) => {
    return (
        <CustomContainer>
            <CustomContainer topMargin="3">
                <AppText textSize="1.8" fontWeight="700" color="#27272E">Personal details</AppText>
                <FlexRow gap='4' topMargin="3" wrap="wrap" alignItems="flex-start">
                    <CustomContainer width="14">
                        <AppLabel textSize="1.2" color="#718096">First Name</AppLabel>
                        <AppText textSize="1.2" color=" #101225">{data?.firstName}</AppText>
                    </CustomContainer>
                    <CustomContainer width="14">
                        <AppLabel textSize="1.2" color="#718096">Last Name</AppLabel>
                        <AppText textSize="1.2" color=" #101225">{data?.lastName}</AppText>
                    </CustomContainer>
                    <CustomContainer width="14">
                        <AppLabel textSize="1.2" color="#718096">Date of Birth</AppLabel>
                        <AppText textSize="1.2" color=" #101225">{data?.dateOfBirth}</AppText>
                    </CustomContainer>
                    <CustomContainer width="14">
                        <AppLabel textSize="1.2" color="#718096">Gender</AppLabel>
                        <AppText textSize="1.2" color=" #101225">{data?.gender}</AppText>
                    </CustomContainer>
                    <CustomContainer width="14">
                        <AppLabel textSize="1.2" color="#718096">Email</AppLabel>
                        <AppText textSize="1.2" color=" #101225">{data?.email}</AppText>
                    </CustomContainer>
                    <CustomContainer width="14">
                        <AppLabel textSize="1.2" color="#718096">Phone Number 1</AppLabel>
                        <AppText textSize="1.2" color=" #101225">{data?.phoneNumber}</AppText>
                    </CustomContainer>
                    <CustomContainer width="14">
                        <AppLabel textSize="1.2" color="#718096">Phone Number 2</AppLabel>
                        <AppText textSize="1.2" color=" #101225">N/A</AppText>
                    </CustomContainer>
                    <CustomContainer width="14">
                        <AppLabel textSize="1.2" color="#718096">Marital Status</AppLabel>
                        <AppText textSize="1.2" color=" #101225">{data?.maritalStatus}</AppText>
                    </CustomContainer>
                    <CustomContainer width="14">
                        <AppLabel textSize="1.2" color="#718096">BVN</AppLabel>
                        <AppText textSize="1.2" color=" #101225">{data?.bvn}</AppText>
                    </CustomContainer>
                </FlexRow>
                <CustomContainer topMargin="5">
                    <AppText fontWeight="600" color="#27272E">Residential Address</AppText>
                    <FlexRow gap='4' topMargin="2" wrap="wrap" alignItems="flex-start">
                        <CustomContainer width="auto" sizeUnit="">
                            <FlexRow >
                                <AppLabel textSize="1.2" color="#718096" >Address</AppLabel>
                                <GridContainer 
                                    bgColor={data?.isAddressVerified ? "#DEFFEE": "#FF5050"} radius="2.1" height="1.6" leftMargin="0.5"
                                    leftPadding="1" rightPadding="1" width="auto" sizeUnit="" topMargin="-0.4"
                                >
                                    <AppSpan textSize="1" fontWeight="600" color={data?.isAddressVerified ? "#4AAE8C": '#ffffff'}>{data?.isAddressVerified ? 'Verified': 'Not Verified'}</AppSpan>
                                </GridContainer>
                            </FlexRow>
                            <FlexRow alignItems="flex-start">
                                <AppText textSize="1.2" color=" #101225" rightMargin="0.5">{data?.address}</AppText>
                                { data?.isAddressVerified &&
                                    <AiFillCheckCircle style={{color: '#25BE76'}}/>
                                }
                            </FlexRow>
                        </CustomContainer>
                        <CustomContainer width="10">
                            <AppLabel textSize="1.2" color="#718096">Landmark</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.landmark}</AppText>
                        </CustomContainer>
                        <CustomContainer width="11">
                            <AppLabel textSize="1.2" color="#718096">LGA</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.lga}</AppText>
                        </CustomContainer>
                        <CustomContainer width="10">
                            <AppLabel textSize="1.2" color="#718096">State</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.state}</AppText>
                        </CustomContainer>
                        <CustomContainer width="10">
                            <AppLabel textSize="1.2" color="#718096">Country</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.country}</AppText>
                        </CustomContainer>
                    </FlexRow>
                </CustomContainer>
                <Divider margin="4" bgColor="rgba(203, 213, 224, 0.4)"/>
                <CustomContainer topMargin="2">
                    <AppText fontWeight="600" color="#27272E">Loan Details</AppText>
                    <FlexRow gap='4' topMargin="2" wrap="wrap" alignItems="flex-start">
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Customer ID</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.customerId}</AppText>
                        </CustomContainer>
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Account State</AppLabel>
                            <FlexRow alignItems="flex-start">
                                <AppText textSize="1.2" color=" #101225" rightMargin="0.5">{data?.isAccountVerified ? 'Verified' : 'Not Verified'}</AppText>
                                { data?.isAccountVerified &&
                                    <AiFillCheckCircle style={{color: '#25BE76'}}/>
                                }
                            </FlexRow>
                        </CustomContainer>
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Date created</AppLabel>
                            {/* <AppText textSize="1.2" color=" #101225">28/11/2021, 2:58pm</AppText> */}
                        </CustomContainer>
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Running Loan</AppLabel>
                            {/* <AppText textSize="1.2" color=" #101225">Yes</AppText> */}
                        </CustomContainer>
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Lending</AppLabel>
                            {/* <AppText textSize="1.2" color=" #101225">Yes</AppText> */}
                        </CustomContainer>
                    </FlexRow>
                </CustomContainer>
            </CustomContainer>
            <Divider margin="4" bgColor="rgba(203, 213, 224, 0.4)"/>
            <CustomContainer topMargin="1">
                <AppText fontWeight="600" color="#16192C">Bank details</AppText>
                <FlexRow gap='4' topMargin="2" wrap="wrap" alignItems="flex-start">
                    <CustomContainer width="13">
                        <AppLabel textSize="1.2" color="#718096">Account Name</AppLabel>
                        <AppText textSize="1.2" color=" #101225">{data?.bankInfo?.accountName}</AppText>
                    </CustomContainer>
                    <CustomContainer width="13">
                        <AppLabel textSize="1.2" color="#718096">Account Number</AppLabel>
                        <AppText textSize="1.2" color=" #101225">{data?.bankInfo?.accountNumber}</AppText>
                    </CustomContainer>
                    <CustomContainer width="13">
                        <AppLabel textSize="1.2" color="#718096">Bank Name</AppLabel>
                        <AppText textSize="1.2" color=" #101225">{data?.bankInfo?.bankName}</AppText>
                    </CustomContainer>
                    <CustomContainer width="13">
                        <AppLabel textSize="1.2" color="#718096">Account Status</AppLabel>
                        <FlexRow alignItems="flex-start">
                            <AppText textSize="1.2" color=" #101225" rightMargin="0.5">{data?.bankInfo?.accountStatus}</AppText>
                            { data?.bankInfo?.accountStatus === 'Active' &&
                                <AiFillCheckCircle style={{color: '#25BE76'}}/>
                            }
                        </FlexRow>
                    </CustomContainer>
                </FlexRow>
                <Divider margin="4" bgColor="rgba(203, 213, 224, 0.4)"/>
                <CustomContainer topMargin="2">
                    <AppText fontWeight="600" color="#16192C">Employment</AppText>
                    <FlexRow gap='4' topMargin="2" wrap="wrap" alignItems="flex-start">
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Employment Status</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.employment?.employmentStatus}</AppText>
                        </CustomContainer>
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Employer</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.employment?.employer}</AppText>
                        </CustomContainer>
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Monthly Income</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.employment?.monthlyIncome}</AppText>
                        </CustomContainer>
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Sector</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.employment?.sector}</AppText>
                        </CustomContainer>
                        {/* <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Sub Sector</AppLabel>
                            <AppText textSize="1.2" color=" #101225">Finance</AppText>
                        </CustomContainer> */}
                    </FlexRow>
                </CustomContainer>
                <Divider margin="4" bgColor="rgba(203, 213, 224, 0.2)"/>
                <CustomContainer topMargin="2">
                    <AppText fontWeight="600" color="#16192C">Education</AppText>
                    <FlexRow gap='4' topMargin="2" wrap="wrap" alignItems="flex-start">
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Education Level</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.educationalQualification}</AppText>
                        </CustomContainer>
                    </FlexRow>
                </CustomContainer>
                <Divider margin="4" bgColor="rgba(203, 213, 224, 0.2)"/>
                <CustomContainer topMargin="2">
                    <AppText textSize="1.8" fontWeight="600" color="#16192C">Onboarding Status</AppText>
                    <FlexRow gap='4' topMargin="2" wrap="wrap" alignItems="flex-start">
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Status</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.hasCompletedOnboarding ? 'Completed' : 'Not Completed'}</AppText>
                        </CustomContainer>
                        <CustomContainer width="18">
                            <AppLabel textSize="1.2" color="#718096">Percentage Completion</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.onboardingPercentageCompletion}%</AppText>
                        </CustomContainer>
                    </FlexRow>

                    <CustomContainer topMargin="3">
                        <AppText fontWeight="600" color="#16192C">Onboarding Stages Status</AppText>
                        <FlexRow gap='4' topMargin="2" wrap="wrap" alignItems="flex-start">
                            {
                                data?.onboardingHistories?.map((item: any, index: number) => {
                                    return (
                                        <CustomContainer width="13" key={index}>
                                            <AppLabel textSize="1.2" color="#718096">{item.stage}</AppLabel>
                                            <AppText textSize="1.2" color=" #101225">{item.status}</AppText>
                                        </CustomContainer>
                                    )
                                })
                            }
                        </FlexRow>
                    </CustomContainer>
                </CustomContainer>
            </CustomContainer>
            <Divider margin="4" bgColor="rgba(203, 213, 224, 0.4)"/>
            <CustomContainer topMargin="1">
                <AppText textSize="1.8" fontWeight="700" color="#27272E">Next of Kin details</AppText>
                <CustomContainer topMargin="3.5">
                    <AppText fontWeight="600" color="#16192C">Next of Kin</AppText>
                    <FlexRow gap='4' topMargin="2" wrap="wrap" alignItems="flex-start">
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">First Name</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.nextOfKin?.firstName}</AppText>
                        </CustomContainer>
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Last Name</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.nextOfKin?.lastName}</AppText>
                        </CustomContainer>
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Relationship with Next of Kin</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.nextOfKin?.relationship}</AppText>
                        </CustomContainer>
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Email Address</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.nextOfKin?.email}</AppText>
                        </CustomContainer>
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Phone Number</AppLabel>
                            <AppText textSize="1.2" color=" #101225">{data?.nextOfKin?.phoneNumber}</AppText>
                        </CustomContainer>
                    </FlexRow>
                </CustomContainer>
                <CustomContainer topMargin="4">
                    <AppText fontWeight="600" color="#16192C">Residential Address</AppText>
                    <FlexRow gap='4' topMargin="2" wrap="wrap" alignItems="flex-start">
                        <CustomContainer width="23">
                            <AppLabel textSize="1.2" color="#718096">Address</AppLabel>
                            <AppText textSize="1.2" color=" #101225">nill</AppText>
                        </CustomContainer>
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Landmark</AppLabel>
                            <AppText textSize="1.2" color=" #101225">nill</AppText>
                        </CustomContainer>
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">LGA</AppLabel>
                            <AppText textSize="1.2" color=" #101225">nill</AppText>
                        </CustomContainer>
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">State</AppLabel>
                            <AppText textSize="1.2" color=" #101225">nill</AppText>
                        </CustomContainer>
                        <CustomContainer width="13">
                            <AppLabel textSize="1.2" color="#718096">Country</AppLabel>
                            <AppText textSize="1.2" color="#101225">nill</AppText>
                        </CustomContainer>
                    </FlexRow>
                </CustomContainer>
            </CustomContainer>
            <Divider margin="4" bgColor="rgba(203, 213, 224, 0.4)"/>
            <CustomContainer topMargin="1">
                <AppText textSize="1.8" fontWeight="700" color="#27272E">Document</AppText>
                <FlexRow gap="1" topMargin="2" wrap="wrap">
                    <CustomContainer width="24" topPadding="1.2" rightPadding="1.2" >
                        <CustomContainer 
                            width="22.7" height="13.5" radius="0.2" bgColor="#F4F4F4"
                            padding="0.25" bottomMargin="0.8"
                            style={{border: '1px dashed #B8B8B8'}} 
                        >
                            <Icon src={data?.document?.idCard} noResize />
                            
                        </CustomContainer>
                        <AppLabel color="#6F767C">Govt. Issued ID Card</AppLabel>
                        <AbsoluteContainer top="0" right="0.3">
                            <AiFillCheckCircle style={{color: '#27E189', fontSize: '3rem'}}/>
                        </AbsoluteContainer>
                    </CustomContainer>
                    <CustomContainer width="24" topPadding="1.2" rightPadding="1.2" >
                        <CustomContainer 
                            width="22.7" height="13.5" radius="0.2" bgColor="#F4F4F4"
                            padding="0.25" bottomMargin="0.8"
                            style={{border: '1px dashed #B8B8B8'}} 
                        >
                            <Icon src={data?.document?.signature} noResize />
                            
                        </CustomContainer>
                        <AppLabel color="#6F767C">Signature</AppLabel>
                        <AbsoluteContainer top="0" right="0.3">
                            <AiFillCheckCircle style={{color: '#27E189', fontSize: '3rem'}}/>
                        </AbsoluteContainer>
                    </CustomContainer>
                    <CustomContainer width="24" topPadding="1.2" rightPadding="1.2" >
                        <CustomContainer 
                            width="22.7" height="13.5" radius="0.2" bgColor="#F4F4F4"
                            padding="0.25" bottomMargin="0.8"
                            style={{border: '1px dashed #B8B8B8'}} 
                        >
                            <Icon src={data?.document?.picture} />
                            
                        </CustomContainer>
                        <AppLabel color="#6F767C">Passport</AppLabel>
                        <AbsoluteContainer top="0" right="0.3">
                            <AiFillCheckCircle style={{color: '#27E189', fontSize: '3rem'}}/>
                        </AbsoluteContainer>
                    </CustomContainer>
                    {/* <CustomContainer width="24" topPadding="1.2" rightPadding="1.2" >
                        <GridContainer 
                            width="22.7" height="13.5" radius="0.2" bgColor="#F4F4F4"
                            padding="0.25" bottomMargin="0.8"
                            style={{border: '1px dashed #B8B8B8'}} 
                        >
                            <Icon src={Signature} />
                            
                        </GridContainer>
                        <AppLabel color="#6F767C">Signature</AppLabel>
                        <AbsoluteContainer top="0" right="0.3">
                            <AiFillCheckCircle style={{color: '#27E189', fontSize: '3rem'}}/>
                        </AbsoluteContainer>
                    </CustomContainer> */}
                </FlexRow>
            </CustomContainer>
        </CustomContainer>
    )
}